import { memo } from 'react';
import NavigationIcon from '@mui/icons-material/Navigation';

interface WindDirectionCellProps {
  value: number | null;
  windSpeed?: number | null;
}

const WindDirectionCell = memo(({ value, windSpeed }: WindDirectionCellProps) => {
  // Calculate icon size based on wind speed
  const getIconSize = (speed: number | null | undefined) => {
    if (speed === null || speed === undefined) return 1.2;
    const minSize = 0.8; // Size at 0 mph
    const maxSize = 2.5; // Size at 50 mph
    const normalizedSpeed = Math.min(speed, 50) / 50; // Normalize speed to 0-1 range
    return minSize + (maxSize - minSize) * normalizedSpeed;
  };

  if (value === null) return <div style={{ textAlign: 'center' }}>-</div>;

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <NavigationIcon 
        sx={{ 
          transform: `rotate(${value + 180}deg)`,
          transition: 'all 0.2s ease-in-out',
          fontSize: `${getIconSize(windSpeed)}rem`
        }} 
      />
    </div>
  );
}, (prevProps, nextProps) => prevProps.value === nextProps.value);

export default WindDirectionCell;
